export let Code = {
type: `@Component({
    selector: '[pInputText]',
    template:
          <div class="ui-g-12 ui-md-4">
	        <div class="ui-inputgroup">
	            <span class="ui-inputgroup-addon"><i class="fa ion-person"></i></span>
	            <input type="text" pInputText placeholder="Username">         
	        </div>
	    </div>
	    
	    <div class="ui-g-12 ui-md-4">
	        <div class="ui-inputgroup">
	            <span class="ui-inputgroup-addon">$</span>
	            <input type="text" pInputText placeholder="Price">   
	            <span class="ui-inputgroup-addon">.00</span>      
	        </div>
	    </div>
	            
	    <div class="ui-g-12 ui-md-4">
	        <div class="ui-inputgroup">
	            <span class="ui-inputgroup-addon">www</span>
	            <input type="text" pInputText placeholder="Website">      
	        </div>
	    </div>
})
export class InputGroup {

}
`,
typeM: `@Component({
    selector: '[pInputText]',
    template:
	    <div class="ui-inputgroup">
	        <span class="ui-inputgroup-addon"><i class="fa ion-card"></i></span>  
			<span class="ui-inputgroup-addon"><i class="fa ion-cash"></i></span>   
	        <input type="text" pInputText placeholder="Price"> 
	        <span class="ui-inputgroup-addon">$</span>  
	        <span class="ui-inputgroup-addon">.00</span>      
	    </div>
})
export class InputGroup {

}
`,
typeB: `@Component({
    selector: '[pInputText]',
    template:
	    <div class="ui-g-12 ui-md-4">
	        <div class="ui-inputgroup">
	            <button pButton type="button" label="Search"></button>
	            <input type="text" pInputText placeholder="Keyword">         
	        </div>
	    </div>
	    
	    <div class="ui-g-12 ui-md-4">
	        <div class="ui-inputgroup">
	            <input type="text" pInputText placeholder="Keyword">   
	            <button pButton type="button" icon="ion-ios-circle-outline" class="ui-button-secondary"></button>      
	        </div>
	    </div>
	            
	    <div class="ui-g-12 ui-md-4">
	        <div class="ui-inputgroup">
	            <button pButton type="button" icon="ion-android-checkbox-outline-blank" class="ui-button-success"></button>    
	            <input type="text" pInputText placeholder="Vote">   
	            <button pButton type="button" icon="ion-close-round" class="ui-button-danger"></button>      
	        </div>
	    </div>
})
export class InputGroup {

}
`
};


// WEBPACK FOOTER //
// ./src/app/code/inputgroup.ts